<template>
  <a-card>
    <div class="main-panel" style="min-height: 800px">
      <div class="main-title-wrap">
        <div class="main-title">催单管理</div>
      </div>
      <div class="main-content-wrap">
        <div class="main-operation-wrap">
          <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false">
            <a-row :gutter="20">
              <a-col :span="5">
                <a-form-model-item label="运输单号">
                  <a-input v-model="shippingOrderNo" placeholder="请输入运输单号" clearable></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="5">
                <a-form-model-item label="ifs号">
                  <a-input v-model="ifsNo" placeholder="请输入ifs号" clearable></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="5">
                <a-form-model-item label="催件人">
                  <a-input v-model="reminderPerson" placeholder="请输入催件人" clearable></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item label="催件时间">
                  <!--                  <a-date-picker-->
                  <!--                    style="width: 310px"-->
                  <!--                    v-model="time"-->
                  <!--                    type="daterange"-->
                  <!--                    value-format="yyyy-MM-dd"-->
                  <!--                    start-placeholder="开始日期"-->
                  <!--                    end-placeholder="结束日期"-->
                  <!--                    :default-time="['00:00:00', '23:59:59']">-->
                  <!--                  </a-date-picker>-->
                  <a-range-picker
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm:ss' }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['Start Time', 'End Time']"
                    v-model="time"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="3">
                <a-form-model-item label=" ">
                  <a-button type="primary" icon="el-icon-search" @click="search">搜索</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </div>
      <a-row>
        <a-table row-key="id"
                 :loading="table.loading"
                 :data-source="table.data"
                 :default-sort="table.sort"
                 :pagination="table.pagination"
                 @change="handleTableChange"
                 ref="table.dataRef">
          <a-form-model slot="expandedRowRender"
                        slot-scope="record"
                        :label-col="{ span: 7 }"
                        :wrapper-col="{ span: 16 }">
            <a-form-model-item label="wmsNo">
              <span>{{ record.order.wmsNo }}</span>
            </a-form-model-item>
            <a-form-model-item label="ifsNo">
              <span>{{ record.order.ifsNo }}</span>
            </a-form-model-item>
            <a-form-model-item label="快递单号">
              <span>{{ record.order.orderNo }}</span>
            </a-form-model-item>
            <a-form-model-item label="发货时间">
              <span>{{ record.order.deliveryAt }}</span>
            </a-form-model-item>
            <a-form-model-item label="收货地址">
              <span>{{ record.order.receiveAddress }}</span>
            </a-form-model-item>
            <a-form-model-item label="发货地">
              <span>{{ record.order.sendCity }}</span>
            </a-form-model-item>

          </a-form-model>
          <a-table-column
            align="center"
            :sorter="true"
            key="order.ifsNo"
            data-index="order.ifsNo" title="ifsNo" width="120">
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="order.wmsNo"
            data-index="order.wmsNo" title="wms" width="120">
          </a-table-column>
          <a-table-column
            align="center"
            :show-overflow-tooltip='true'
            :sorter="true"
            key="order.customerName"
            data-index="order.customerName" title="客户名称" width="120">
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="order.expressCode"
            data-index="order.expressCode" title="运输商" width="120">
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="order.warningReason"
            data-index="order.warningReason" title="预警原因" width="120">
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="order.warningReason"
            data-index="order.warningReason" title="货物状态" width="120">
            <template slot-scope="text, record">
              <div>{{ record.order.orderStatus === 'DELIVERY' ? '出库': record.order.orderStatus === 'SEND' ? '在途':
                record.order.orderStatus === 'COLLECT' ? '揽收': record.order.orderStatus === 'CLOSED' ? '签收': '新建'}}
              </div>
            </template>
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="reminderTime"
            data-index="reminderTime" title="申请时间" width="120">
            <!--            <template slot-scope="text, record">-->
            <!--              <date-time-formatter :date-time="record.reminderTime"-->
            <!--                                   formatter="YYYY-MM-DD  HH:mm:ss"></date-time-formatter>-->
            <!--            </template>-->
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="isDeal"
            data-index="isDeal" title="是否处理" width="120">
            <template slot-scope="text, record">
              <div>{{record.dealStatus === 0 ? '未处理': '已处理'}}</div>
            </template>
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="dealTime"
            data-index="dealTime" title="处理时间" width="120">
            <!--            <template slot-scope="text, record">-->
            <!--              <date-time-formatter :date-time="record.dealTime"-->
            <!--                                   formatter="YYYY-MM-DD  HH:mm:ss"></date-time-formatter>-->
            <!--            </template>-->
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="customer"
            data-index="customer" title="催单人" width="120">
          </a-table-column>
          <a-table-column
            align="center"
            :sorter="true"
            key="telephone"
            data-index="telephone" title="联系方式" width="120">
          </a-table-column>
          <a-table-column
            :sorter="true"
            key="dealResult"
            data-index="dealResult" title="处理结果" width="120">
          </a-table-column>
          <a-table-column title="操作" align="center">
            <template slot-scope="text, record">
              <a-button type="link" @click="dealTask(record)" :disabled="record.dealStatus === 1">处理</a-button>
            </template>
          </a-table-column>
        </a-table>
      </a-row>
    </div>
    <a-modal v-model="openServiceTask" width="600px" @cancel="onFormCancel" @ok="onFormSave" :destroy-on-close="true">
      <service-task-deal :get-list="getList" :service-task="form" ref="serviceTaskDeal"></service-task-deal>
    </a-modal>
  </a-card>
</template>

<script>

import ServiceTaskDeal from "./ServiceTaskDeal";
import {getServiceTask} from "../../../api/serviceTaskApi";
import DateTimeFormatter from '../../../components/DateTimeFormatter';
import moment from "moment";


function table_index(index) {
  return (this.table.pagination.current - 1) * this.table.pagination.pageSize + index + 1;
}

async function onFormSave() {
  this.$refs.serviceTaskDeal.save();
  this.getList();
  this.openServiceTask = false;
}

async function onFormCancel() {

}

async function getList() {
  let startAt;
  let endAt;
  const timeScope = this.time && this.time.length === 2
    ? this.time : [null, null];
  let formData = new FormData;
  const { order } = this.table.sort;
  formData.append('page', this.table.pagination.current);
  formData.append('size', this.table.pagination.pageSize);
  formData.append('sort', this.table.sort.prop);
  formData.append('direction', order === 'ascend' ? 'ASC' : 'DESC');
  // formData.append("sort", 'deliveryAt');
  // formData.append("direction", 'DESC');
  formData.append("ifs", this.ifsNo);
  formData.append("orderNo", this.shippingOrderNo);
  if (this.time.length > 1) {
    startAt = this.time[0];
    endAt = this.time[1];
    formData.append("startAt", timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null)
    formData.append("endAt", timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null)
  }
  formData.append("reminderPerson", this.reminderPerson);

  const result = await getServiceTask(formData);
  if (result.code === 1200) {
    // this.tableData = result.data.dataList;
    // this.listQuery.total = result.data.totalCount
    this.table.data = result.data.dataList
    this.table.pagination.total = result.data.totalCount;
  } else {
    this.table.data = [];
    this.table.pagination.total = 0;
  }
}

async function dealTask(record) {
  if (record.dealStatus === 0) {
    this.openServiceTask = true;
    this.form = record
    // const result = await changeStatus({
    //   id: record.id
    // })
    // if (result.code === 1200) {
    //   // this.$message("处理成功");
    //   this.$message.success("处理成功")
    //   this.getList()
    // }
  } else {
    this.$message.error("请勿重复处理")
  }
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  if (sorter.field && sorter.order) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    };
  }
  this.getList();
}

export default {
  name: "ServiceTask",
  components: {
    DateTimeFormatter,
    ServiceTaskDeal
  },
  data() {
    return {
      openServiceTask: false,
      shippingOrderNo: '',
      ifsNo: '',
      reminderPerson: '',
      time: [],
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
        sort: {
          prop: 'reminderTime',
          order: 'descend',
        },
      },
      form: {}
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList,
    table_index,
    search() {
      this.getList();
    },
    onFormSave,
    onFormCancel,
    dealTask,
    handleTableChange
  }
}
</script>

<style>
  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
